<script setup>
import FileManager from '@/views/apps/file/list/FileManager.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'bots',
    useBotNav: true,
  },
})

import { useRoute } from 'vue-router'

// Get the bot ID from the route params
const route = useRoute()
const botId = Number.parseInt(route.params.id)
</script>

<template>
  <FileManager
    :bot-id="botId"
    :card-view="false"
    :list-view="false"
    inline-add-new
    disable-bot-selection-in-add-new
  />
</template>

